import React from "react";

type Props = React.SVGProps<SVGSVGElement>;

export const EditPencil = (props: Props) => (
  <>
    <span className="t-sr-only">Pencil</span>
    <svg
      {...props}
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_4913_11946)">
        <path
          d="M13.47 2.5293C13.1301 2.1899 12.6694 1.99927 12.189 1.99927C11.7086 1.99927 11.2479 2.1899 10.908 2.5293L2 11.4373V13.9993H4.562L13.47 5.0913C13.8093 4.75131 13.9998 4.29061 13.9998 3.8103C13.9998 3.32998 13.8093 2.86929 13.47 2.5293V2.5293ZM4.15 12.9993H3V11.8493L9.655 5.1993L10.805 6.3493L4.15 12.9993ZM12.763 4.3843L11.5095 5.6378L10.362 4.4878L11.615 3.2363C11.7675 3.0838 11.9743 2.99813 12.19 2.99813C12.4057 2.99813 12.6125 3.0838 12.765 3.2363C12.9175 3.3888 13.0032 3.59563 13.0032 3.8113C13.0032 4.02697 12.9175 4.2338 12.765 4.3863L12.763 4.3843Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_4913_11946">
          <rect
            width="12"
            height="12"
            fill="white"
            transform="translate(2 2)"
          />
        </clipPath>
      </defs>
    </svg>
  </>
);
